import React from 'react';
import {connect} from 'react-redux';
import {deepClone, sortBy} from 'lodash';


// local imports
import {Link} from "react-router-dom";
import api from '../../../store/api'
import {toggleGlobalLoader, addErrorAlert, addLoadingAlert, removeLoadingAlert} from "../../../store/calls/alertLoadingDispatch";
import validators from "../../../utils/forms/validators";

import AdminWrapper from "../../theme/wrappers/AdminWrapper";

import Input from "../../theme/forms/Input";
import BaseForm from "../../theme/forms/BaseForm";
import PaginatedTable from "../../theme/tables/PaginatedTable";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import FormModal from "../../theme/modals/FormModal";
import PacefiFullScreenSpinner from "../../theme/loaders/pacefiFullScreenSpinner";
import {nullBooleanSelect} from "../../../utils/forms/preconfiguredInputs";
import {getUUID} from "../../../utils/hashFuncs";


export default class AssetTypeAdminScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            displayedData: [],
            dataPullLimit: 25,
            dataPullOffset: 0,

            // edit and delete
            editModalOpen: false,
            deleteModalOpen: false,
            editingInstance: null,

            nameFilter: null,


        }

        this.baseAPIPath = '/treasury-note-yields/'

    }

    componentDidMount() {
        toggleGlobalLoader(true);

        Promise.all([
            this.getData(),
        ])
            .then(() => toggleGlobalLoader(false))
            .catch(() => {
                addErrorAlert('Failed to load all initial data.', 10 * 1000);
                toggleGlobalLoader(false);
            })

    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }


    getData = (xtraParams = {}) => {

        return api.get(this.baseAPIPath, {cacheBust: getUUID()})
            .then(res => {
                this.setState({displayedData: res.data})
            })
    }


    handleDeleteRequest = () => {
        addLoadingAlert();
        api.patch(`${this.baseAPIPath}${this.state.editingInstance.id}/`, {is_active: 0})
            .then(() => this.getData())
            .catch(err => addErrorAlert('Failed to delete.'))
            .finally(() => this.setState({deleteModalOpen: false, editingInstance: null}, removeLoadingAlert))
    }

    handleCreateOrUpdateRequest = (data) => {
        let promise; let err_msg;
        if (this.state.editingInstance && !this.state.editingInstance.bogusKey) {
            promise = () => api.patch(`${this.baseAPIPath}${this.state.editingInstance.id}/`, data)
            err_msg = "Failed to update."
        } else {
            promise = () => api.post(this.baseAPIPath, data)
            err_msg = "Failed to create."
        }

        return promise()
            .then(() => this.getData())
            .catch(err => addErrorAlert(err_msg))
            .finally(() => this.setState({editModalOpen: false, editingInstance: null}, removeLoadingAlert))
    }

     updateRate = (id, rate) => {
         toggleGlobalLoader(true);
         api.patch(this.baseAPIPath + id + '/', {rate})
             .then(res => this.setState({
                 displayedData: this.state.displayedData.map(d => d.id === res.id ? {...res} : d)
             }))
             .catch(() => {
                 addErrorAlert('Failed to update the rate.', 10 * 1000);
             })
             .finally(() => {
                 toggleGlobalLoader(false);
             })
     }




    handleValueChange = (idx, rate) => {
         let {displayedData} = this.state;

         displayedData[idx].rate = rate;
         this.setState({displayedData})
    }


    makeInputs = () => {

        return this.state.displayedData
            .sort((a,b) => a.term < b.term ? -1 : 1)
            .map((tbill, idx) => (
                <Input
                    label={tbill.term + " year rate"}
                    type="text"
                    classNames="is-medium mb-5"
                    value={tbill.rate}
                    onChange={val => this.handleValueChange(idx, val)}
                    addOns={[
                        <button
                            className="button is-info"
                            onClick={() => this.updateRate(tbill.id, tbill.rate)}
                        >
                            Update
                        </button>
                    ]}
                />
            ))


    }


    render() {
        return (
            <AdminWrapper>
                <div className="section">
                    <div className="container is-fullhd mx-6">
                        <div className="level mb-6">
                            <div className="level-left">
                                <div className="level-item">
                                    <h2 className="title is-2 is-info">Treasury Yields</h2>
                                </div>
                            </div>
                            <div className="level-right" />
                        </div>
                        {this.makeInputs()}
                    </div>
                </div>



            </AdminWrapper>
        )
    }

}

